import React from 'react';

const block = 'create-service-request';

export interface CreateServiceRequestSuccessViewProps {
  title: React.ReactNode;
  description: React.ReactNode;
  isPrivateRequest: boolean;
  onGoToMyRequests: () => void;
  onViewAllOrProfile: () => void;
}

const CreateServiceRequestSuccessView: React.FC<
  CreateServiceRequestSuccessViewProps
> = ({
  title,
  description,
  isPrivateRequest,
  onGoToMyRequests,
  onViewAllOrProfile,
}) => (
  <div className={`${block} ${block}--success`}>
    <div className={`${block}__success-content`}>
      {title}
      {description}
      <div className={`${block}__success-actions`}>
        <button
          type="button"
          className={`${block}__btn ${block}__btn--primary`}
          onClick={onGoToMyRequests}>
          Go to My Requests
        </button>
        <button
          type="button"
          className={`${block}__btn ${block}__btn--secondary`}
          onClick={onViewAllOrProfile}>
          {isPrivateRequest ? 'Back to Profile' : 'View All Requests'}
        </button>
      </div>
    </div>
  </div>
);

export default CreateServiceRequestSuccessView;
